export const gridStateKeys = {
    BoqGridState: 'boqGridState',
    RawMaterialGridState: 'rawMaterialGridState',
    AdjustRmGridState: 'adjustRmGridState',
    AdjBktReportGridState: 'adjBktReportGridState',
    CustomerGridState: 'customerGridState',
    ScreenMainGridState: 'screenMainGridState',
    BatchReportsTableGridState: 'batchReportsTableGridState',
    ProductionGridState: 'productionGridState',
    BucketInventoryGridState: 'bucketInventoryGridState',
    AdjRmReportGridState: 'adjRmReportGridState',
    SalesReportGridState: 'salesReportGridState',
    StockOutReportsTableGridState: 'stockOutReportsTableGridState',
    RawMaterialReportGridState: 'rawMaterialReportGridState',
    StockInventoryGridState: 'stockInventoryGridState',
    BucketReportGridState: 'bucketReportGridState',
    BucketSalesGridState: 'bucketSalesGridState',
    AdjustBktGridState: 'adjustBktGridState',
    BucketGridState: 'bucketGridState'
}